import { CONSTANTS } from "src/app/constants";
import { IPump } from "../interfaces/pump.interface";

export class Pump implements IPump {
  pumpId: string;
  pumpName: string;
  pumpMaxFlowRate: number;
  pumpMinFlowrate: number;
  pumpMaxPressure: number;
  pumpDischargePressure: number;
  pumpmodelName: string;
  pumpmodelSupplier: string;

  constructor(pump: IPump) {
    Object.keys(pump).map(key => this[key] = pump[key]);
  }

  get isNoPump(): boolean {
    return this.pumpId.includes(CONSTANTS.EQUIPMENTS.NO_PUMP);
  }
}